import * as React from "react";
import { Suspense } from "react";
import Tabs from "@mui/material/Tabs";
import Box from "@mui/material/Box";
import PropTypes from "prop-types";
import {
  StyledTabsBarBox,
  StyledHeadingTabsGroup,
  StyledHeadingWrap,
  StyledText,
  StyledHeaderButton,
  StyledTab,
  StyledTabsWrapper,
  StyledBox,
  StyledTabComponent,
} from "./CustomTabs.style";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function CustomTabs({ headerTitle, tabs = [], headerButton }) {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <>
      <StyledBox>
        <StyledTabsBarBox>
          <StyledHeadingTabsGroup>
            <StyledHeadingWrap>
              <StyledText data-testid="custom-tabs-header">{headerTitle}</StyledText>
            </StyledHeadingWrap>
            <StyledTabsWrapper>
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="tabs"
                variant="scrollable"
                scrollButtons="auto"
                allowScrollButtonsMobile
              >
                {tabs?.map((tab, index) => (
                  <StyledTab
                    key={index}
                    label={tab?.label}
                    {...a11yProps(index)}
                  />
                ))}
              </Tabs>
            </StyledTabsWrapper>
          </StyledHeadingTabsGroup>
          {headerButton?.showButton && (
            <StyledHeaderButton
              variant="outlined"
              onClick={() => headerButton?.onClickHandler?.()}
            >
              {headerButton?.label}
            </StyledHeaderButton>
          )}
        </StyledTabsBarBox>
        <StyledTabComponent hasSubTabs={tabs?.[value]?.hasSubTabs}>
          {tabs?.map((tab, index) => {
            const Component = tab?.component;
            return (
              <CustomTabPanel key={index} value={value} index={index}>
                {Component && (
                  <Suspense fallback={<div>Loading...</div>}>
                    <Component />
                  </Suspense>
                )}
              </CustomTabPanel>
            );
          })}
        </StyledTabComponent>
      </StyledBox>
    </>
  );
}

CustomTabs.propTypes = {
  headerTitle: PropTypes.string.isRequired,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      component: PropTypes.node.isRequired,
      hasSubTabs: PropTypes.bool,
    })
  ).isRequired,
  headerButton: PropTypes.shape({
    showButton: PropTypes.bool,
    label: PropTypes.string,
    onClickHandler: PropTypes.func,
  }),
};

CustomTabs.defaultProps = {
  headerButton: {
    showButton: false,
  },
};
